import React, { Component } from 'react';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card } from 'primereact/card';
import { growlErrors } from '../../../../../utils/NotificationUtil';
import { toggleUsingJPS } from '../../../../../services/apps/JobProfileService';
import { withGrowl } from '../../../../../components/GrowlNotifications';
import { withAccount } from '../../../../../components/AccountContext';


const i18nMsg = defineMessages({
  sendInvite: {
    id: 'assessment.invite.send',
    defaultMessage: 'Send Invite',
  },
  sendRemind: {
    id: 'assessment.remind.send',
    defaultMessage: 'Send Reminder',
  },
  remove: {
    id: 'del_header.jps.spec',
    defaultMessage: 'Delete Job Profile Survey',
  },
  previewInvite: {
    id: 'assessment.invite.preview',
    defaultMessage: 'Preview Invite',
  },
  previewRemind: {
    id: 'assessment.remind.preview',
    defaultMessage: 'Preview Remind',
  },
  deleteWarning: {
    id: 'jps.delete.warning',
    defaultMessage: 'This Job Profile Survey respondent will automatically be deleted on: ',
  },
});

const getItemStatus = () => ({
  NEW:
    (
      <div className="filter is-active">
        <FormattedMessage id="candidate.status.NEW" defaultMessage="NEW" />
      </div>
    ),
  INVITED:
    (
      <div className="filter filter--info is-active">
        <FormattedMessage id="candidate.status.INVITED" defaultMessage="INVITED" />
      </div>
    ),
  STARTED:
    (
      <div className="filter filter--warning is-active">
        <FormattedMessage id="candidate.status.STARTED" defaultMessage="IN PROGRESS" />
      </div>
    ),
  DECLINED:
    (
      <div className="filter filter--error is-active">
        <FormattedMessage id="candidate.status.DECLINED" defaultMessage="DECLINED" />
      </div>
    ),
  EXPIRED:
    (
      <div className="filter filter--error is-active">
        <FormattedMessage id="candidate.status.EXPIRED" defaultMessage="EXPIRED" />
      </div>
    ),
  SUBMITTED:
    (
      <div className="filter filter--success is-active">
        <FormattedMessage id="candidate.status.SUBMITTED" defaultMessage="ASSESSED" />
      </div>
    ),
});

class HintJPSCard extends Component {
  constructor(props) {
    super(props);
    const { item } = this.props;
    this.state = {
      itemChecked: item.useForHints ? item.useForHints : false,
      cardActions: [],
    };
    this.handlePreviewInviteEmail = this.handlePreviewInviteEmail.bind(this);
    this.handlePreviewRemindEmail = this.handlePreviewRemindEmail.bind(this);
  }

  componentDidMount() {
    const { item } = this.props;
    this.buildCsActions(item);
  }

  buildCsActions(item) {
    const {
      intl, onInvite, onReminder, onRemove,
    } = this.props;
    const { formatMessage } = intl;
    const cardActions = [
    ];

    const { status, scheduledForDeletionOn } = item;
    if (status === 'NEW') {
      const newAction = {
        label: formatMessage(i18nMsg.sendInvite),
        command: () => onInvite(item.id),
      };
      cardActions.push(newAction);
    } else if (status === 'STARTED' || status === 'INVITED') {
      const newAction = {
        label: formatMessage(i18nMsg.sendRemind),
        command: () => onReminder(item.id),
      };
      cardActions.push(newAction);
    }

    if (!scheduledForDeletionOn) {
      cardActions.push(
        {
          label: formatMessage(i18nMsg.remove),
          command: () => onRemove(item.id),
        },
      );
    }

    cardActions.push(
      {
        label: formatMessage(i18nMsg.previewInvite),
        command: () => this.handlePreviewInviteEmail(),
      },
      {
        label: formatMessage(i18nMsg.previewRemind),
        command: () => this.handlePreviewRemindEmail(),
      },
    );


    this.setState({ cardActions });
  }

  async handleToggleJPS(id) {
    const { growl, jobId, currentAccount } = this.props;
    const { itemChecked } = this.state;
    const input = {
      id,
      jobProfileId: jobId,
      isUsed: !itemChecked,
      accountId: currentAccount,
    };
    try {
      const response = await toggleUsingJPS(input);
      this.setState({ itemChecked: response.toggleJobProfileSurvey.value });
    } catch (err) {
      growlErrors(growl, err);
    }
  }

  handlePreviewInviteEmail() {
    const { item } = this.props;
    const { previewInviteUrl } = item;
    window.open(previewInviteUrl, '_blank');
  }

  handlePreviewRemindEmail() {
    const { item } = this.props;
    const { previewReminderUrl } = item;
    window.open(previewReminderUrl, '_blank');
  }

  render() {
    const {
      item, currentAccount,
      nameJobProfile, jobId, intl,
    } = this.props;
    const { formatMessage, formatDate } = intl;
    if (!item) {
      return (
        <div className="card" data-t="cs-item">
          <div className="card-column card-addon">
            <FormattedMessage
              id="lbl.no_item"
              defaultMessage="No Item"
            />
          </div>
        </div>
      );
    }
    const status = item.status ? item.status : item.assessment.status;
    const detailUrl = `/accounts/${currentAccount}/jps/${item.id}`;
    const { itemChecked, cardActions } = this.state;
    return (
      <div className="p-grid">
        <div className="p-col">
          <Card>
            {
              status === 'SUBMITTED'
              && <input type="checkbox" checked={itemChecked} onChange={() => this.handleToggleJPS(item.id)} />
            }
            <Link
              to={{
                pathname: detailUrl,
                state: {
                  prevPath:
                    [
                      { link: `/accounts/${currentAccount}/job-profiles`, name: 'menu.jobs', defaultMessage: true },
                      {
                        link: `/accounts/${currentAccount}/job-profiles/${jobId}`,
                        name: nameJobProfile,
                        defaultMessage: false,
                      },
                    ],
                },
              }}
            >
              {item.respondent.firstName}
              {' '}
              {item.respondent.lastName}
            </Link>
            {' '}
            {status && getItemStatus()[status]}
            {item.respondent.email}
            {
              item.scheduledForDeletionOn && (
                <Button
                  className="p-button-warning"
                  icon="pi pi-info"
                  label={formatMessage(i18nMsg.deleteWarning)
                    + formatDate(new Date(item.scheduledForDeletionOn),
                      {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}
                />
              )
            }
          </Card>
        </div>
        <div className="p-col-2 p-col-align-center">
          <Menu
            model={cardActions}
            appendTo={document.body}
            popup
            ref={(el) => { this.menu = el; }}
          />
          <Button
            icon="pi pi-ellipsis-h"
            className="p-button-secondary"
            onClick={(event) => { this.menu.toggle(event); }}
          />
        </div>
      </div>
    );
  }
}

HintJPSCard.propTypes = {
  item: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired,
  }).isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  nameJobProfile: PropTypes.string.isRequired,
  jobId: PropTypes.string.isRequired,
  onInvite: PropTypes.func.isRequired,
  onReminder: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default withAccount(
  withGrowl(
    injectIntl(
      HintJPSCard,
    ),
  ),
);
